// var api_url = 'https://kult.lyxelandflamingotech.in/api/check-inventory';
var api_url = "https://sap.kenstar.in/api/check-inventory-new";
var KenstarPincodePopup = window.KenstarPincodePopup || {};
KenstarPincodePopup.apiBaseUrl =
  KenstarPincodePopup.apiBaseUrl || "http://127.0.0.1:8000/api";
KenstarPincodePopup.storageKey =
  KenstarPincodePopup.storageKey || "kenstar_delivery_pincode";
var pincode_serviceability_api_url =
  KenstarPincodePopup.serviceabilityApiUrl ||
  KenstarPincodePopup.apiBaseUrl + "/pincode/serviceability";
var pincode_inventory_api_url =
  KenstarPincodePopup.inventoryApiUrl ||
  KenstarPincodePopup.apiBaseUrl + "/inventory/availability";
var pincode_inventory_batch_api_url =
  KenstarPincodePopup.inventoryBatchApiUrl ||
  KenstarPincodePopup.apiBaseUrl + "/inventory/availability/batch";
var pendingPincodeCartAdd = null;
var pincodePopupSource = null;
var pdpInventoryRequest = null;
var pdpInventoryRequestId = 0;
var pdpInventoryDebounceTimer = null;

// Pincode helper: accepts only 6 digit Indian pincodes that do not start with zero.
function isValidIndianPincode(pincode) {
  return /^[1-9][0-9]{5}$/.test(String(pincode || "").trim());
}

// Pincode helper: localStorage is primary, cookie is kept for older theme code compatibility.
function getSavedPincode() {
  return (
    window.localStorage.getItem(KenstarPincodePopup.storageKey) ||
    getCookie("pincode") ||
    ""
  );
}

// Pincode helper: shows the header delivery bar only after a pincode has been saved.
function updateHeaderPincodeDisplay(pincode) {
  var value = pincode || getSavedPincode();
  $("[data-pincode-display]").text(value);
  $("[data-pincode-topbar]").prop("hidden", !value);
}

// Pincode popup helper: the on-demand modal can always be dismissed without changing the cart.
function updatePincodePopupCloseState() {
  $("#location-modal").attr("data-pincode-required", "false");
  $("#popup-close")
    .prop("disabled", false)
    .attr("aria-disabled", "false");
}

// Pincode helper: persists the pincode and notifies PDP/PLP/cart inventory checks.
function savePincode(value) {
  window.localStorage.setItem(KenstarPincodePopup.storageKey, value);
  setCookie("pincode", value, 30);
  $(".pincode").val(value);
  updateHeaderPincodeDisplay(value);
  updatePincodePopupCloseState();
  document.dispatchEvent(
    new CustomEvent("kenstar:pincode-changed", { detail: { pincode: value } })
  );
}

// Pincode popup helper: opens the shared modal and pre-fills the saved pincode.
function openPincodePopup(source) {
  pincodePopupSource = source || pincodePopupSource;
  $("#popupPincode").val(getSavedPincode());
  $("#pincodePopupMessage").html("");
  updatePincodePopupCloseState();
  $("body").addClass("pincode-popup-open");
  $("#location-modal").show();
  setTimeout(function () {
    $("#popupPincode").trigger("focus");
  }, 50);
}

// Pincode popup helper: closes the modal and restores normal page/cart form state.
function closePincodePopup() {
  $("#location-modal").hide();
  $("body").removeClass("pincode-popup-open");
  $('[data-type="add-to-cart-form"]').css("opacity", 1);
  pincodePopupSource = null;
}

window.KenstarPincodePopup = Object.assign(KenstarPincodePopup, {
  getPincode: getSavedPincode,
  savePincode: savePincode,
  open: openPincodePopup,
  close: closePincodePopup,
});

// Pincode bootstrap: wires popup controls and starts PDP, product-card, and cart checks.
function initKenstarPincodeFeatures() {
  updateHeaderPincodeDisplay();
  updatePincodePopupCloseState();
  $(document).on("click", "[data-pincode-open]", function (event) {
    event.preventDefault();
    openPincodePopup("topbar");
  });
  initPincodePdpInventoryCheck();
  initPincodeProductCardInventoryCheck();
  initPincodeCartInventoryCheck();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initKenstarPincodeFeatures);
} else {
  initKenstarPincodeFeatures();
}

// Pincode PDP inventory helper: reads the Shopify variant ID to SKU map rendered by Liquid.
function getPdpVariantSkuMap() {
  var mapScript = $('[id^="PincodePdpVariantSkuMap-"]').first();

  if (!mapScript.length) {
    return {};
  }

  try {
    return JSON.parse(mapScript.text());
  } catch (error) {
    console.warn("Pincode PDP SKU map could not be parsed.", error);
    return {};
  }
}

// Pincode PDP inventory helper: returns the selected variant ID from the product form.
function getPdpSelectedVariantId($form) {
  return $('[name="id"]', $form).val() || $(".product-variant-id").first().val();
}

// Pincode PDP inventory helper: returns the SKU for the selected variant.
function getPdpSelectedSku($form) {
  var variantId = getPdpSelectedVariantId($form);
  var skuMap = getPdpVariantSkuMap();

  return skuMap[variantId] || $('[name="sku"]', $form).val() || "";
}

// Pincode PDP inventory helper: returns the requested PDP quantity.
// function getPdpRequestedQuantity($form) {
//   var quantity =
//     $('[name="quantity"]', $form).val() ||
//     $('[name="quantityTemp"]', $form).val() ||
//     $(".quantity__input").first().val() ||
//     1;

//   quantity = parseInt(quantity, 10);

//   return Number.isNaN(quantity) || quantity < 1 ? 1 : quantity;
// }

function getPdpRequestedQuantity($form) {

    var quantity = parseInt($('.quantity__input', $form).val(), 10);

    if (isNaN(quantity) || quantity < 1) {
        quantity = parseInt($('#pdpQty').val(), 10);
    }

    if (isNaN(quantity) || quantity < 1) {
        quantity = 1;
    }

    return quantity;
}

// // PDP quantity helper: applies the lower of Shopify's native maximum and pincode inventory.
// function setPdpInventoryQuantityLimit(availableQuantity) {
//   var limit = Math.max(parseInt(availableQuantity, 10) || 0, 0);

//   $(".quantity__input, [name='quantityTemp']").each(function () {
//     var $input = $(this);
//     var nativeMax = $input.data("pincode-native-max");

//     if (nativeMax === undefined) {
//       nativeMax = parseInt($input.attr("max"), 10) || 0;
//       $input.data("pincode-native-max", nativeMax);
//     }

//     var effectiveMax = nativeMax > 0 ? Math.min(nativeMax, limit) : limit;

//     if (effectiveMax > 0) {
//       $input.attr("max", effectiveMax).attr("data-pincode-inventory-max", effectiveMax);

//       if ((parseInt($input.val(), 10) || 1) > effectiveMax) {
//         $input.val(effectiveMax);
//         $("[data-pincode-pdp-form] [name='quantity']").val(effectiveMax);
//       }
//     }

//     $input.closest(".wrap, quantity-input").find("[name='plus'], .add")
//       .prop("disabled", effectiveMax < 1)
//       .toggleClass("disabled", effectiveMax < 1 || (parseInt($input.val(), 10) || 1) >= effectiveMax);
//   });
// }
// ============================================================
// ============================================================
// PDP PINCODE INVENTORY QUANTITY LIMIT
// HARD MAXIMUM = 2
// ============================================================

function setPdpInventoryQuantityLimit(availableQuantity) {

  var inventoryQty = parseInt(availableQuantity, 10) || 0;

  // ----------------------------------------------------------
  // HARD MAXIMUM
  // No matter what inventory is, customer cannot exceed 2
  // ----------------------------------------------------------

  var limit = Math.min(inventoryQty, 2);

  // If inventory is 0, limit remains 0
  if (inventoryQty <= 0) {
    limit = 0;
  }

  $(".quantity__input, [name='quantityTemp']").each(function () {

    var $input = $(this);

    // --------------------------------------------------------
    // Store Shopify's original/native maximum only once
    // --------------------------------------------------------

    var nativeMax = $input.data("pincode-native-max");

    if (nativeMax === undefined) {

      nativeMax = parseInt(
        $input.attr("max"),
        10
      ) || 0;

      $input.data(
        "pincode-native-max",
        nativeMax
      );
    }


    // --------------------------------------------------------
    // Calculate effective maximum
    // --------------------------------------------------------

    var effectiveMax = nativeMax > 0
      ? Math.min(nativeMax, limit)
      : limit;


    // --------------------------------------------------------
    // Store pincode inventory limit
    // --------------------------------------------------------

    if (effectiveMax > 0) {

      $input
        .attr("max", effectiveMax)
        .attr(
          "data-pincode-inventory-max",
          effectiveMax
        );


      // ------------------------------------------------------
      // Make sure current quantity isn't above limit
      // ------------------------------------------------------

      var currentQty = parseInt(
        $input.val(),
        10
      );

      if (isNaN(currentQty)) {
        currentQty = 1;
      }


      if (currentQty > effectiveMax) {

        $input.val(effectiveMax);

        $("[data-pincode-pdp-form] [name='quantity']")
          .val(effectiveMax);
      }
    }


    // --------------------------------------------------------
    // Keep + button ENABLED
    // --------------------------------------------------------

    $input
      .closest(".wrap, quantity-input")
      .find("[name='plus'], .add")
      .prop("disabled", false)
      .removeAttr("disabled")
      .removeClass("disabled");

  });
}



// ============================================================
// REMOVE OLD HANDLERS
// ============================================================

$(document).off(
  "click.pincodeInventory",
  "[name='plus'], .add"
);



// ============================================================
// INTERCEPT + BUTTON BEFORE SHOPIFY
// ============================================================

document.addEventListener(
  "pointerdown",
  function (event) {

    var button = event.target.closest(
      "[name='plus'], .add"
    );

    if (!button) {
      return;
    }


    var $button = $(button);


    // --------------------------------------------------------
    // Find quantity input
    // --------------------------------------------------------

    var $input = $button
      .closest(".wrap, quantity-input")
      .find(
        ".quantity__input, [name='quantityTemp']"
      )
      .first();


    if (!$input.length) {
      return;
    }


    // --------------------------------------------------------
    // Get current quantity
    // --------------------------------------------------------

    var currentQty = parseInt(
      $input.val(),
      10
    );

    if (isNaN(currentQty)) {
      currentQty = 1;
    }


    // ========================================================
    // HARD LIMIT = 2
    // ========================================================

    if (currentQty >= 2) {

      console.log(
        "QUANTITY LIMIT REACHED:",
        currentQty
      );


      // ------------------------------------------------------
      // Stop Shopify quantity increment
      // ------------------------------------------------------

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();


      // ------------------------------------------------------
      // Keep button enabled
      // ------------------------------------------------------

      $button
        .prop("disabled", false)
        .removeAttr("disabled")
        .removeClass("disabled");


      // ------------------------------------------------------
      // Show alert
      // ------------------------------------------------------

      window.alert(
        "You can't add more quantity."
      );


      return false;
    }

  },
  true
);

// PDP quantity helper: returns the first visible quantity input after clamping or manual edits.
function getCurrentPdpQuantityValue() {
  var $input = $(".quantity__input, [name='quantityTemp']").first();
  var quantity = parseInt($input.val(), 10) || parseInt($("[data-pincode-pdp-form] [name='quantity']").first().val(), 10) || 1;

  return Math.max(quantity, 1);
}

// PDP helper: clears temporary highlight once the customer starts correcting the pincode input.
function clearPdpPincodePrompt() {
  var $checkForm = $("[data-pincode-pdp-check-form]").first();

  $checkForm.removeClass("pincode-pdp-form-highlight");
  $("[data-pincode-pdp-form-message]", $checkForm).text("").removeClass("error");
}

// PDP helper: brings the pincode box into view and explains why add to cart is blocked.
function promptForPdpPincode() {
  var $checkForm = $("[data-pincode-pdp-check-form]").first();
  var $input = $("[name='pincode']", $checkForm).first();
  var $message = $("[data-pincode-pdp-form-message]", $checkForm).first();

  if (!$checkForm.length || !$input.length) {
    return;
  }

  $checkForm.addClass("pincode-pdp-form-highlight");
  $message
    .text("Please enter your Pincode to check availability.")
    .addClass("error");

  if ($checkForm[0].scrollIntoView) {
    $checkForm[0].scrollIntoView({ behavior: "smooth", block: "center" });
  }

  window.setTimeout(function () {
    $input.trigger("focus");
  }, 250);
}

// Pincode PDP inventory helper: updates PDP add-to-cart buttons and status message.
function setPdpInventoryState(state, message) {
  var $forms = $("[data-pincode-pdp-form]");
  var $buttons = $("[data-pincode-pdp-submit]");
  var $messages = $("[data-pincode-pdp-message]");

  $buttons.each(function () {
    var $button = $(this);
    var $label = $("span", $button).first();
    var nativeSoldOut = $button.attr("data-pincode-native-sold-out") === "true";

    if (!$button.data("original-label")) {
      $button.data("original-label", $label.html().trim() || $button.html().trim());
    }

    if (nativeSoldOut) {
      $button.attr("disabled", true);
      $label.text("Sold Out");
      $(".sticky-add-to-cart").show();
    } else if (state === "checking") {
      $button.attr("disabled", true);
      $label.text("Checking...");
      $(".sticky-add-to-cart").show();
    } else if (state === "needs-pincode") {
      $button.removeAttr("disabled");
      $label.html($button.data("original-label"));
      $(".sticky-add-to-cart").show();
    } else if (state === "available") {
      $button.removeAttr("disabled");
      $label.html($button.data("original-label"));
      $(".sticky-add-to-cart").show();
    } else {
      $button.attr("disabled", true);
      $label.text("Sold Out");
      $(".sticky-add-to-cart").show();
    }
  });

  $forms.attr("data-pincode-inventory-state", state);

  if (!$messages.length) {
    return;
  }

  if (!message) {
    $messages.html("");
    return;
  }

  var className = state === "available" ? "success" : "error";
  $messages.html('<div class="' + className + '">' + message + "</div>");
}




//function to set date dynamically....

function getDeliveryDates(minDays, maxDays) {
  const options = {
    day: "numeric",
    month: "short"
  };

  const from = new Date();
  from.setDate(from.getDate() + minDays);

  const to = new Date();
  to.setDate(to.getDate() + maxDays);

  return {
    from: from.toLocaleDateString("en-IN", options),
    to: to.toLocaleDateString("en-IN", options)
  };
}


// PDP request helper: collapses rapid quantity/variant changes into one inventory check.
function schedulePdpInventoryRefresh(delay) {
  window.clearTimeout(pdpInventoryDebounceTimer);
  pdpInventoryDebounceTimer = window.setTimeout(function () {
    pdpInventoryDebounceTimer = null;
    refreshPdpInventoryAvailability();
  }, typeof delay === "number" ? delay : 350);
}

// PDP request helper: cancels superseded API work and invalidates its callbacks.
function cancelPdpInventoryRequest() {
  pdpInventoryRequestId += 1;

  if (pdpInventoryRequest && pdpInventoryRequest.readyState !== 4) {
    pdpInventoryRequest.abort();
  }

  pdpInventoryRequest = null;
}

// Pincode PDP inventory check: calls the local backend for the selected SKU, pincode, and quantity.
function refreshPdpInventoryAvailability() {
  window.clearTimeout(pdpInventoryDebounceTimer);
  pdpInventoryDebounceTimer = null;

  var $form = $("[data-pincode-pdp-form]").first();

  if (!$form.length) {
    cancelPdpInventoryRequest();
    return;
  }

  var pincode = getSavedPincode();
  var sku = getPdpSelectedSku($form);
  var quantity = getPdpRequestedQuantity($form);

  if (!pincode) {
    cancelPdpInventoryRequest();
    clearPdpPincodePrompt();
    setPdpInventoryState("needs-pincode", "");
    return;
  }

  if (!sku) {
    cancelPdpInventoryRequest();
    setPdpInventoryState("unavailable", "SKU is missing for this product.");
    return;
  }

  cancelPdpInventoryRequest();
  var requestId = pdpInventoryRequestId;
  setPdpInventoryState("checking", "Checking delivery availability...");

  pdpInventoryRequest = $.ajax({
    url: pincode_inventory_api_url,
    type: "POST",
    cache: false,
    timeout: 10000,
    contentType: "application/json",
    data: JSON.stringify({
      pincode: pincode,
      sku: sku,
      quantity: quantity,
    }),
    success: function (response) {
      if (requestId !== pdpInventoryRequestId) {
        return;
      }

      setPdpInventoryQuantityLimit(response.available_quantity);
      var availableQuantity = Math.max(parseInt(response.available_quantity, 10) || 0, 0);
      var adjustedQuantity = getCurrentPdpQuantityValue();

      if (response.available === true) {
        if (getSavedPincode() !== pincode) {
          savePincode(pincode);
        }
        // setCookie("deliver", 1, 1);
        // setPdpInventoryState(
        //   "available",
        //   response.message || "Delivery is available for this pincode."
        // );
         setCookie("deliver", 1, 1);
    const dates = getDeliveryDates(4, 7); // or any default SLA

setPdpInventoryState(
    "available",
    `
    <div class="delivery-info">
  
        <div class="delivery-bottom">
            Estimated delivery from
            <strong>${dates.from}</strong>
            to
            <strong>${dates.to}</strong>
        </div>
    </div>
    `
);
      } else if (availableQuantity > 0 && adjustedQuantity <= availableQuantity) {
        setCookie("deliver", 1, 1);
        setPdpInventoryState(
          "available",
          "Only " + availableQuantity + " unit" + (availableQuantity === 1 ? " is" : "s are") +
            " available for delivery to this pincode. Quantity has been updated."
        );
      } else {
        setCookie("deliver", 0, 1);
        setPdpInventoryState(
          "unavailable",
          response.message || "Product is not available for this pincode."
        );
      }
    },
    error: function (_xhr, status) {
      if (requestId !== pdpInventoryRequestId || status === "abort") {
        return;
      }

      setCookie("deliver", 0, 1);
      setPdpInventoryState("unavailable", "Unable to confirm availability right now. Please try again in a moment.");
    },
    complete: function () {
      if (requestId === pdpInventoryRequestId) {
        pdpInventoryRequest = null;
      }
    },
  });
}

// Pincode PDP inventory bootstrap: wires load, pincode changes, quantity changes, and variant changes.
function initPincodePdpInventoryCheck() {
  if (!$("[data-pincode-pdp-form]").length) {
    return;
  }

  refreshPdpInventoryAvailability();
  $("[data-pincode-pdp-check-form] [name='pincode']").val(getSavedPincode());

  document.addEventListener("kenstar:pincode-changed", refreshPdpInventoryAvailability);

  $(document).on("input change", "[data-pincode-pdp-check-form] [name='pincode']", function () {
    clearPdpPincodePrompt();
  });

  // Stop the theme's legacy plus-button handler before it can exceed the API inventory maximum.
  document.addEventListener("click", function (event) {
    var plusButton = event.target.closest && event.target.closest(".pdp-right .add, .quantity__button[name='plus']");

    if (!plusButton) {
      return;
    }

    var $input = $(plusButton).closest(".wrap, quantity-input").find(".quantity__input, [name='quantityTemp']").first();
    var max = parseInt($input.attr("data-pincode-inventory-max"), 10) || 0;
    var quantity = parseInt($input.val(), 10) || 1;

    if (max > 0 && quantity >= max) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  // PDP pincode form: validates and saves the value; the change event runs the selected SKU check.
  $(document).on("submit", "[data-pincode-pdp-check-form]", function (event) {
    event.preventDefault();
    var $form = $(this);
    var $input = $("[name='pincode']", $form);
    var $button = $("button[type='submit']", $form);
    var $message = $("[data-pincode-pdp-form-message]", $form);
    var pincode = String($input.val() || "").trim();

    if (!isValidIndianPincode(pincode)) {
      $form.addClass("pincode-pdp-form-highlight");
      $message.text("Please enter a valid 6 digit pincode.").addClass("error");
      return;
    }

    clearPdpPincodePrompt();
    $button.prop("disabled", true).text("Checking...");
    savePincode(pincode);


        // NEW: delivery_check dataLayer event
    var ctx = window.kenstarPageContext || {};
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'delivery_check',
      'page_name': ctx.page_name || '',
      'page_url': ctx.page_url || '',
      'page_type': ctx.page_type || 'product',
      'page_category': ctx.page_category || '',
      'user_logged_in': ctx.user_logged_in || false,
      'user_type': ctx.user_type || 'guest',
      'store_id': ctx.store_id || '',
      'zipcode': pincode,
      'customer_id': ctx.customer_id || '',
      'ecommerce': {
        'items': [
          {
            'item_id': ctx.item_id || '',
            'item_name': ctx.item_name || '',
            'item_category': ctx.item_category || ''
          }
        ]
      }
    });

    window.setTimeout(function () {
      $button.prop("disabled", false).text("Apply");
    }, 800);
  });

  // $(document).on("change input", ".quantity__input, [name='quantityTemp']", function () {
  //   var quantity = getPdpRequestedQuantity($("[data-pincode-pdp-form]").first());
  //   $("[data-pincode-pdp-form] [name='quantity']").val(quantity);
  //   refreshPdpInventoryAvailability();
  // });


$(document).on(
    "change input",
    ".quantity__input, [name='quantityTemp']",
    function () {

        var quantity = parseInt($(this).val()) || 1;

        $('#pdpQty').val(quantity);

        schedulePdpInventoryRefresh();

});

  $(document).on("change", ".product-variant-id, [name='id']", function () {
    schedulePdpInventoryRefresh(100);
  });

  // Capture submit before Shopify's product-form element can post the product without a pincode check.
  document.addEventListener("submit", function (event) {
    var form = event.target.closest && event.target.closest("[data-pincode-pdp-form]");

    if (!form) {
      return;
    }

    var state = $(form).attr("data-pincode-inventory-state");

    if (state === "needs-pincode") {
      event.preventDefault();
      event.stopImmediatePropagation();
      promptForPdpPincode();
      return;
    }

    if (state !== "available") {
      event.preventDefault();
      event.stopImmediatePropagation();
      refreshPdpInventoryAvailability();
    }
  }, true);
}

// Pincode product-card inventory helper: stores the original button label before JS changes it.
function rememberProductCardButtonLabel($button) {
  if ($button.data("original-label")) {
    return;
  }

  var $textLabel = $(".k-d-none", $button).first();
  var label = $textLabel.length ? $textLabel.text().trim() : $button.text().trim();

  $button.data("original-label", label || "Add To Bag");
}

// Pincode product-card inventory helper: updates one card button after batch availability is known.
function setProductCardInventoryState($card, state, message) {
  var $button = $("[data-pincode-card-submit]", $card).first();
  var $textLabel = $(".k-d-none", $button).first();

  if (!$button.length) {
    return;
  }

  rememberProductCardButtonLabel($button);
  $card.attr("data-pincode-card-state", state);
  $card.attr("data-pincode-card-message", message || "");

  if (state === "checking") {
    $button.attr("disabled", true);
    if ($textLabel.length) {
      $textLabel.text("Checking...");
    }
    return;
  }

  if (state === "needs-pincode") {
    $button.removeAttr("disabled");
    $button.removeClass("sold-out");
    if ($textLabel.length) {
      $textLabel.text($button.data("original-label"));
    }
    return;
  }

  if (state === "available") {
    $button.removeAttr("disabled");
    $button.removeClass("sold-out");
    if ($textLabel.length) {
      $textLabel.text($button.data("original-label"));
    }
    return;
  }

  $button.attr("disabled", true);
  $button.addClass("sold-out");
  if ($textLabel.length) {
    $textLabel.text("Sold Out");
  }
}

// Pincode product-card inventory helper: returns unchecked cards with a SKU.
function getUncheckedProductCards() {
  return $("[data-pincode-product-card]")
    .filter(function () {
      var $card = $(this);
      return !$card.attr("data-pincode-card-checked") && !!$card.attr("data-pincode-sku");
    });
}

// Product-card helper: preserves Shopify sold-out state without checking regional stock on page load.
function refreshProductCardInventoryAvailability() {
  var $cards = getUncheckedProductCards();

  $cards.each(function () {
    var $card = $(this);
    var shopifyAvailable = $card.attr("data-pincode-shopify-available") === "true";

    $card.attr("data-pincode-card-checked", "true");
    setProductCardInventoryState(
      $card,
      shopifyAvailable ? "available" : "unavailable",
      shopifyAvailable ? "" : "Product is sold out."
    );
  });
}

// Pincode product-card inventory helper: clears card results when pincode changes.
function resetProductCardInventoryAvailability() {
  $("[data-pincode-product-card]").removeAttr("data-pincode-card-checked");
  refreshProductCardInventoryAvailability();
}

// Add-to-cart helper: checks only the product the customer has chosen.
function checkSingleSkuInventory(pincode, sku, quantity) {
  return $.ajax({
    url: pincode_inventory_api_url,
    type: "POST",
    cache: false,
    contentType: "application/json",
    data: JSON.stringify({ pincode: pincode, sku: sku, quantity: quantity || 1 }),
  });
}

// Cart helper: removes existing lines that cannot be delivered to a confirmed new pincode.
async function refreshCartForPincode(pincode) {
  var cartResponse = await fetch("/cart.js", { credentials: "same-origin" });
  var cart = await cartResponse.json();

  if (!cart.items || !cart.items.length) {
    return;
  }

  var quantitiesBySku = {};

  cart.items.forEach(function (item) {
    if (item.sku) {
      quantitiesBySku[item.sku] = (quantitiesBySku[item.sku] || 0) + item.quantity;
    }
  });

  var inventoryResponse = await fetch(pincode_inventory_batch_api_url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      pincode: pincode,
      items: Object.keys(quantitiesBySku).map(function (sku) {
        return { sku: sku, quantity: quantitiesBySku[sku] };
      }),
    }),
  });
  var inventory = await inventoryResponse.json();
  var unavailableSkus = (inventory.items || [])
    .filter(function (item) { return item.available !== true; })
    .map(function (item) { return item.sku; });
  var updates = {};

  cart.items.forEach(function (item) {
    if (unavailableSkus.indexOf(item.sku) !== -1) {
      updates[item.key] = 0;
    }
  });

  if (!Object.keys(updates).length) {
    return;
  }

  var updateResponse = await fetch("/cart/update.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ updates: updates }),
  });

  if (!updateResponse.ok) {
    throw new Error("Shopify cart refresh failed.");
  }
}

// Add-to-cart coordinator: opens the pincode modal only when input or a new area is required.
function requestPincodeCartAdd($form, sku, variantId, quantity) {
  var pincode = getSavedPincode();
  var $button = $("[data-pincode-card-submit], [data-pincode-pdp-submit]", $form).first();
  var request = {
    form: $form,
    sku: sku || getPdpSelectedSku($form),
    variantId: variantId || getPdpSelectedVariantId($form),
    quantity: quantity || getPdpRequestedQuantity($form),
  };

  pendingPincodeCartAdd = request;

  if (!pincode) {
    openPincodePopup();
    return;
  }

  $button.attr("disabled", true).css("opacity", 0.5);
  checkSingleSkuInventory(pincode, request.sku, request.quantity)
    .done(function (response) {
      if (response.available === true) {
        pendingPincodeCartAdd = null;
        addProductToCart(request.variantId, request.form, false, request.quantity);
      } else {
        var $card = request.form.closest("[data-pincode-product-card]");

        setProductCardInventoryState(
          $card,
          "unavailable",
          response.message || "Product is not available for this pincode."
        );
        $button.css("opacity", 1);
        openPincodePopup();
        $("#pincodePopupMessage").html(
          '<div class="error">This product is unavailable for your current pincode. Try another pincode.</div>'
        );
      }
    })
    .fail(function () {
      $button.removeAttr("disabled").css("opacity", 1);
      alert("Inventory could not be checked right now. Please try again.");
    });
}

// Pincode product-card submit helper: adds available card variants to cart without leaving PLP/home.
function submitPincodeProductCard($form) {
  var $card = $form.closest("[data-pincode-product-card]");
  var $button = $("[data-pincode-card-submit]", $form).first();
  var variantId = $('[name="id"]', $form).val();
  var quantity = parseInt($('[name="quantity"]', $form).val(), 10) || 1;

  requestPincodeCartAdd($form, $card.attr("data-pincode-sku"), variantId, quantity);
}

// Pincode product-card inventory bootstrap: checks initial cards and observes PLP load-more/filter DOM changes.
function initPincodeProductCardInventoryCheck() {
  refreshProductCardInventoryAvailability();
  document.addEventListener("kenstar:pincode-changed", resetProductCardInventoryAvailability);

  // Capture the submit before the legacy slide-cart delegate can add the item without a pincode check.
  document.addEventListener("submit", function (event) {
    var form = event.target.closest && event.target.closest("[data-pincode-card-form]");

    if (!form) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    submitPincodeProductCard($(form));
  }, true);

  if (!window.MutationObserver) {
    return;
  }

  var observerTimer;
  var observer = new MutationObserver(function (mutations) {
    var containsProductCardChange = mutations.some(function (mutation) {
      if (
        mutation.type === "attributes" &&
        mutation.target.matches &&
        mutation.target.matches("[data-pincode-product-card]")
      ) {
        return true;
      }

      return Array.prototype.some.call(mutation.addedNodes, function (node) {
        if (node.nodeType !== 1) {
          return false;
        }

        return (
          (node.matches && node.matches("[data-pincode-product-card]")) ||
          (node.querySelector && node.querySelector("[data-pincode-product-card]"))
        );
      });
    });

    if (!containsProductCardChange) {
      return;
    }

    window.clearTimeout(observerTimer);
    observerTimer = window.setTimeout(refreshProductCardInventoryAvailability, 150);
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: [
      "data-pincode-product-card",
      "data-pincode-sku",
      "data-pincode-shopify-available",
    ],
  });
}

// Cart inventory helper: reads SKU and current quantity from the custom cart line-item forms.
function getCartInventoryItems() {
  return $(".cart-order-item[data-sku]")
    .map(function () {
      var $item = $(this);
      var sku = String($item.attr("data-sku") || "").trim();
      var quantity =
        parseInt($(".count", $item).first().val(), 10) ||
        parseInt($item.attr("data-qty"), 10) ||
        1;

      if (!sku) {
        return null;
      }

      return {
        sku: sku,
        quantity: Math.max(quantity, 1),
      };
    })
    .get();
}

// Cart inventory helper: applies the existing red `.invalid` treatment to unavailable lines.
function markUnavailableCartLines(results) {
  var inventoryBySku = {};

  (results || []).forEach(function (item) {
    inventoryBySku[item.sku] = item;
  });

  $(".cart-order-item[data-sku]").each(function () {
    var $item = $(this);
    var sku = String($item.attr("data-sku") || "").trim();
    var result = inventoryBySku[sku];
    var requestedQuantity =
      parseInt($(".count", $item).first().val(), 10) ||
      parseInt($item.attr("data-qty"), 10) ||
      1;
    var availableQuantity = result ? parseInt(result.available_quantity, 10) || 0 : 0;
    var $quantityMessage = $("[data-cart-inventory-quantity-message]", $item);

    $item.toggleClass("invalid", !!result && result.available !== true);

    if (result && availableQuantity > 0 && requestedQuantity > availableQuantity) {
      $quantityMessage.text(
        "Only " + availableQuantity + " unit" + (availableQuantity === 1 ? " is" : "s are") +
        " available for delivery to this pincode."
      );
    } else {
      $quantityMessage.text("");
    }
  });
}

// Cart inventory helper: covers custom cart links, native checkout buttons, and dynamic checkout fallbacks.
function getCartCheckoutTriggers() {
  return $(
    '.cartCheckout, .cart__checkout-button, [name="checkout"], a[href="/checkout"]'
  );
}

// Cart inventory helper: creates one reusable message area next to the visible checkout action.
function ensureCartInventoryMessage() {
  var $message = $("[data-pincode-cart-message]").first();

  if ($message.length) {
    return $message;
  }

  $message = $('<div class="pincode-cart-message" data-pincode-cart-message role="alert"></div>');
  $(".cartCheckout").first().before($message);

  if (!$message.parent().length) {
    $(".cart__checkout-button").first().before($message);
  }

  return $message;
}

// Cart inventory helper: visually blocks checkout while keeping controls clickable for validation feedback.
function setCartCheckoutBlocked(blocked, message) {
  var $triggers = getCartCheckoutTriggers();
  var $message = ensureCartInventoryMessage();

  $triggers
    .toggleClass("pincode-cart-checkout-blocked", blocked)
    .attr("aria-disabled", blocked ? "true" : "false");

  $triggers.filter("button, input").prop("disabled", false);

  if (blocked) {
    $message.text(message || "Some cart items are not available for your delivery pincode.").show();
  } else {
    $message.text("").hide();
  }
}

// Cart inventory check: final batch validation before customer can leave /cart for checkout.
function refreshCartInventoryAvailability() {
  var items = getCartInventoryItems();
  var pincode = getSavedPincode();

  if (!items.length) {
    setCartCheckoutBlocked(false);
    return;
  }

  if (!pincode) {
    setCartCheckoutBlocked(true, "Please enter your delivery pincode before checkout.");
    return;
  }

  setCartCheckoutBlocked(true, "Checking final inventory availability...");

  $.ajax({
    url: pincode_inventory_batch_api_url,
    type: "POST",
    cache: false,
    contentType: "application/json",
    data: JSON.stringify({
      pincode: pincode,
      items: items,
    }),
    success: function (response) {
      markUnavailableCartLines(response.items || []);
      var unavailableItems = (response.items || []).filter(function (item) {
        return item.available !== true;
      });

      if (response.available === true && !unavailableItems.length) {
        setCartCheckoutBlocked(false);
        return;
      }

      setCartCheckoutBlocked(
        true,
        response.message || "Some cart items are not available for your delivery pincode."
      );
    },
    error: function () {
      $(".cart-order-item").removeClass("invalid");
      $("[data-cart-inventory-quantity-message]").text("");
      setCartCheckoutBlocked(
        true,
        "Inventory could not be checked right now. Please try again before checkout."
      );
    },
  });
}

// Cart inventory bootstrap: validates on load, pincode changes, and delayed cart quantity/remove updates.
function initPincodeCartInventoryCheck() {
  // The mini cart also uses `.cartCheckout`; only the full /cart page needs the batch inventory guard.
  if (!document.body || !document.body.classList.contains("main-cart")) {
    return;
  }

  if (!$(".cart-order-item[data-sku]").length && !$(".cartCheckout, .cart__checkout-button").length) {
    return;
  }

  refreshCartInventoryAvailability();
  $("[data-pincode-cart-form] [name='pincode']").val(getSavedPincode());
  document.addEventListener("kenstar:pincode-changed", refreshCartInventoryAvailability);

  $(document).on("submit", "[data-pincode-cart-form]", function (event) {
    event.preventDefault();
    var $form = $(this);
    var $input = $("[name='pincode']", $form);
    var $button = $("button[type='submit']", $form);
    var $message = $("[data-pincode-cart-form-message]", $form);
    var pincode = String($input.val() || "").trim();

    if (!isValidIndianPincode(pincode)) {
      $message.text("Please enter a valid 6 digit pincode.").addClass("error");
      return;
    }

    $message.text("").removeClass("error");
    $button.prop("disabled", true).text("Checking...");
    savePincode(pincode);

    window.setTimeout(function () {
      $button.prop("disabled", false).text("Apply");
    }, 800);
  });

  $(document).on("click", ".pincode-cart-checkout-blocked", function (event) {
    event.preventDefault();
    event.stopImmediatePropagation();

    if (!getSavedPincode()) {
      $("[data-pincode-cart-form] [name='pincode']").trigger("focus");
    }

    refreshCartInventoryAvailability();
  });

  $(document).on("click", ".addcart, .subcart, cart-remove-button, .cart-close", function () {
    window.setTimeout(refreshCartInventoryAvailability, 900);
  });
}

// Legacy cart helper: posts one variant to Shopify cart and refreshes the slide cart markup.
function addProductToCart(id, card, hidePopup, qty) {
  // var xhttp = new XMLHttpRequest();
  $.ajax({
    url: "/cart/add",
    type: "post",
    data: { id: id, quantity: qty ? qty : 1 },
    success: function (response) {
      $cart = $(response);
      let drawer = $("<div />").append(response).find("#slideCart").html();
      let count = $("#headerCartCount", $cart).text();
      $("#slideCart").html(drawer);
      $(".cartCount").html(count);
      toggleSlideCart();
      $(card).css("opacity", "1");
      $("[data-pincode-card-submit]", card).removeAttr("disabled").css("opacity", 1);
      $('[data-type="add-to-cart-form"]').css("opacity", 1);
      if (hidePopup === true) {
        $("#location-modal").hide();
      }
      // xhttp.open("POST", "/cart/clear.js", true);
      // xhttp.send();
      // crietoCart();
      if (typeof crietoCart === "function") {
    crietoCart();
}
    },
    error: function (err) {
      alert("You can't add more quantity");
      $(card).css("opacity", "1");
      $("[data-pincode-card-submit]", card).removeAttr("disabled").css("opacity", 1);
    },
  });
}
// Legacy pincode helper: mirrors the saved pincode into older `.pincode` inputs.
function getLocalPincode() {
  var pincode = getSavedPincode();
  //var deliver = getCookie('deliver');
  var status = !!pincode;
  $(".pincode").val(pincode);
  /*
  if(pincode){
    if(deliver == 1){
      $('.deliverAtPincode').html('<div class="success">'+deliverMsg+'</div>');
      status = true;
    }else{
      $('.deliverAtPincode').html('<div class="error">'+notDeliverMsg+'</div>')
    }
  }
  */
  return status;
}
$(".checkDelivery").submit(function (e) {
  e.preventDefault();
  var pincode = $("#pincode").val();
  // var type = $('[name="type"]').val();
  products[0].pincode = pincode;
  //products.sku_id = $('{{ product.sku }}')
  //products.qty = $('#pdpQty').val();
  //console.log('sdfdsfd')

  var $btn = $(".cartCheckout", this);
  var $form = $(this);
  $btn.attr("disabled", 1).html("Please Wait...");
  $(".cart-order-item").removeClass("invalid");
  $(".response", $form).html("");
  setCookie("pincode", pincode, 1);

  // Legacy cart checkout helper: checks each cart SKU through the older SAP inventory API.
  async function checkDeliverySKUCheckout(){
    let isValid = true;
    var invalid = [];
    for(let i = 0;i<products.length;i++){
      let p = products[i];
      console.log(p)
      let sku = document.querySelector(`[data-sku="${p.sku_id}"]`)
      p.pincode = pincode;
      let response = await checkSKUDelivery(p);
      if(response == true || response === true || response == 'true'){
        sku.classList.remove('invalid');
      }else{
        sku.classList.add('invalid');
        isValid = false;
        invalid.push(p.sku_id);
      }
    }
    
    if (isValid == true) {
      //setCookie('deliver',1,1);
      beginCheckout();
      window.location.href = "/checkout";
    } else {
      $(".response", $form).html(
        '<div class="error">Red marked products not servicable or out of stock at your location.</div>'
      );
      //setCookie('deliver',0,1);
    }
    $btn.removeAttr("disabled").html("Checkout");

  }
  checkDeliverySKUCheckout()
  return false;
  $.ajax({
    url: api_url,
    type: "post",
    cache: false,
    data: products[0],
    success: function (response) {
      var isValid = true;
      var invalid = [];

      //for (const obj of response.data) {
      // Loop through the keys and values of each object
      for (let [key, value] of Object.entries(response.data)) {
        console.log(value)
        if (value == 0 || !value) {
          key = key.replace(/\//g,'_')
          invalid.push(key);
          $(".sku_" + key.replace(/ /g, "_")).addClass("invalid");
          isValid = false;
        }
      }
      //}
      if (isValid == true) {
        //setCookie('deliver',1,1);
        beginCheckout();
        window.location.href = "/checkout";
      } else {
        $(".response", $form).html(
          '<div class="error">Red marked products not servicable or out of stock at your location.</div>'
        );
        //setCookie('deliver',0,1);
      }
      $btn.removeAttr("disabled").html("Checkout");
    },
    error: function (err) {
      $(".response", $form).html(
        '<div class="error">Server Error!! Please try again later.</div>'
      );
      $btn.removeAttr("disabled").html("Checkout");
      //setCookie('deliver',0);
    },
  });
});
// Legacy API helper: returns true when the older SAP inventory response has stock for every returned location.
async function checkSKUDelivery(product){
   let isValid = true;
    let response = await fetch(`${api_url}?${new URLSearchParams(product).toString()}`,{
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: "",
    });
    if(!response.ok){
      return false;
    }
    response = await response.json();
    console.log('response',response)
    for (const [key, value] of Object.entries(response.data)) {
      if (value == 0 || !value) {
        isValid = false;
      }
    }
    return isValid;
}

$("#popupPincodeForm").submit(async function (e) {
  e.preventDefault();
  var value = $(".pincode", this).val().trim();
  var form = this;
  var oldPincode = getSavedPincode();
  var pincodeChanged = !!oldPincode && oldPincode !== value;

  $(".response", form).html("");

  if (!isValidIndianPincode(value)) {
    $(".response", form).html(
      '<div class="error">Please enter a valid 6 digit pincode.</div>'
    );
    return;
  }

  if (pincodeChanged && (pendingPincodeCartAdd || pincodePopupSource === "topbar") && !window.confirm(
    "Changing your delivery pincode may update your cart. Items that cannot be delivered to the new pincode will be removed. Would you like to continue?"
  )) {
    return;
  }

  $("button", form).attr("disabled", true).css("opacity", 0.2).text("Checking...");

  try {
    if (pendingPincodeCartAdd) {
      var request = pendingPincodeCartAdd;
      var inventory = await checkSingleSkuInventory(value, request.sku, request.quantity);

      if (inventory.available !== true) {
        $(".response", form).html(
          '<div class="error">This product is not available for delivery to this pincode.</div>'
        );
        return;
      }

      await refreshCartForPincode(value);
      savePincode(value);
      setCookie("deliver", 1, 1);
      pendingPincodeCartAdd = null;
      $(".response", form).html(
        '<div class="success">This product is available for your pincode and has been added to your cart.</div>'
      );
      addProductToCart(request.variantId, request.form, false, request.quantity);
      window.setTimeout(closePincodePopup, 1400);
    } else {
      var serviceability = await $.ajax({
        url: pincode_serviceability_api_url,
        type: "POST",
        cache: false,
        contentType: "application/json",
        data: JSON.stringify({ pincode: value }),
      });

      if (serviceability.serviceable !== true) {
        $(".response", form).html(
          '<div class="error">Delivery is not available for this pincode.</div>'
        );
        return;
      }

      if (pincodePopupSource === "topbar") {
        await refreshCartForPincode(value);
      }

      savePincode(value);
      closePincodePopup();
    }
  } catch (error) {
    $(".response", form).html(
      '<div class="error">We could not check availability right now. Please try again.</div>'
    );
  } finally {
    $("button", form).removeAttr("disabled").css("opacity", 1).text("Proceed");
  }
});
$("#popup-close").on("click", function (e) {
  e.preventDefault();
  pendingPincodeCartAdd = null;
  closePincodePopup();
});
// Cookie helper: stores simple theme state such as pincode/delivery status.
function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
// Cookie helper: reads simple theme state written by setCookie().
function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
